import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import classes from './TransformerDataComponent.css';
import TwoOptionsSelector from '../UI/Selectors/TwoOptionsSelector/TwoOptionsSelector';
import SPTransformerVTSelector from './TransformerSelectors/TransformerVoltageSelectors/SPTransformerVoltageSelector/SPTransformerVoltageSelector';
import TPTransformerVTSelector from './TransformerSelectors/TransformerVoltageSelectors/TPTransformerVoltageSelector/TPTransformerVoltageSelector';
import LocalizedStrings from '../../assets/data/LocalizedStrings/LocalizedStrings.json';

class TransformerDataComponent extends Component {
  state = {
    selectedSP: true,
    selectedTP: false
  };

  handleSPSelection = () => {
    this.setState({
      selectedSP: true,
      selectedTP: false
    });
  };

  handleTPSelection = () => {
    this.setState({
      selectedSP: false,
      selectedTP: true
    });
  };

  render() {
    const { selectedSP, selectedTP } = this.state;
    const { country, language } = this.props;

    return (
      <Fragment>
        <TwoOptionsSelector
          title1={LocalizedStrings[language].sp}
          title2={LocalizedStrings[language].tp}
          select1={this.handleSPSelection}
          select2={this.handleTPSelection}
          selected1={selectedSP}
          selected2={selectedTP}
        />
        {selectedSP ? (
          <SPTransformerVTSelector country={country} language={language} />
        ) : (
          <TPTransformerVTSelector country={country} language={language} />
        )}
        <div className={classes.TitleWrapper}>
          <h3>{LocalizedStrings[language].dryTransformerData}</h3>
        </div>
      </Fragment>
    );
  }
}

TransformerDataComponent.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default TransformerDataComponent;
